import { useMatch, useRouterState } from "@tanstack/react-router";

const withoutTrailingSlash = (path: string) => path.replace(/\/+$/, "") || "/";

export function useScrollPlaced(): boolean {
    const pathname = useMatch({
        strict: false,
        select: (match) => withoutTrailingSlash(match.pathname),
    });
    return useRouterState({
        select: (state) =>
            state.resolvedLocation !== undefined &&
            withoutTrailingSlash(state.resolvedLocation.pathname) === pathname,
    });
}
